// extracted by mini-css-extract-plugin
export default {"menu-item":"styles_menu-item__-DRJT","upload-btn":"styles_upload-btn__KU+s0"};